// Badge — Soft (tinted bg) or Solid, 12px uppercase semibold.

import { cn } from '@/lib/utils'

type BadgeVariant = 'solid' | 'soft'

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant
}

const variantClasses: Record<BadgeVariant, string> = {
  solid: 'bg-primary text-primary-foreground',
  soft: 'bg-primary/10 text-primary',
}

export function Badge({
  variant = 'solid',
  className,
  children,
  ...props
}: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-[12px] font-semibold uppercase tracking-wide',
        variantClasses[variant],
        className
      )}
      {...props}
    >
      {children}
    </span>
  )
}
